module.exports = __webpack_public_path__ + "img/weibo.877b1c06.png";